import React from 'react';

import { Namespace } from '../../translation/namespace';
import { FooterBlock } from '../../_blocks/Footer';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { isFooterBlock } from '../../_blocks/Footer/FooterBlock';

export type FooterSection = {
  blocks?: [FooterBlock];
  uuid: string;
};

export function FooterSection({ blocks }: FooterSection) {
  const { t } = useSonTranslation(Namespace.FooterSection);

  const footer = blocks?.find(isFooterBlock);

  if (!footer) {
    return null;
  }

  return (
    <footer className="footer" aria-label={t('footerHeading')}>
      <FooterBlock {...footer} />
    </footer>
  );
}
